import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { IManagableObject } from "../../../admin-panel/IManagableObject";

@Component({
  selector: 'app-group-filter',
  templateUrl: './group-filter.component.html',
  styleUrls: ['./group-filter.component.css'],
  standalone: false
})
export class GroupFilterComponent implements AfterViewInit, OnInit {

  @Input()
  public groups: IManagableObject[] = [];

  @Input()
  public isEditable: boolean = true;

  @Input()
  public canEditGroup: (group: IManagableObject) => boolean;

  @Input()
  public canDeleteGroup: (group: IManagableObject) => boolean;

  public groupNameFilter: string;

  public allGroupsItem: IManagableObject = new class implements IManagableObject {
    Id: number;
    IsChecked: boolean;
    Name: string;
  };
  public selectedGroup: IManagableObject = this.allGroupsItem;


  @Output() onAddGroup: EventEmitter<any> = new EventEmitter();
  @Output() onEditGroup: EventEmitter<any> = new EventEmitter();
  @Output() onDeleteGroup: EventEmitter<any> = new EventEmitter();
  @Output() onSelectGroup: EventEmitter<any> = new EventEmitter();

  public onTermChange(term: Event) {
    const input = term.target as HTMLInputElement;
    this.groupNameFilter = input.value;
  }

  constructor(private translate: TranslateService, private elementRef: ElementRef) { }

  ngOnInit() {
    this.allGroupsItem.Name = this.translate.instant("All");
    this.translate.onLangChange.subscribe(() =>
      this.allGroupsItem.Name = this.translate.instant("All"));
    this.allGroupsItem.Id = -1;
  }

  ngAfterViewInit() {
    document.dispatchEvent(new Event("readyAgain"));
  }

  public openMgmtDropdown(group: any, event: any) {
    this.groups.forEach((grp: any) => {
      if (grp.Id == group.Id) {
        group.isMgmtOpen = true;
        group.mgmtyPos = event.clientY + 10;
        group.mgmtxPos = event.clientX + 10;
      } else {
        grp.isMgmtOpen = false;
      }
    });
  }

  public addGroup() {
    this.closeMgmtDropdowns();
    this.onAddGroup.emit();
  }

  public editGroup(group: IManagableObject) {
    this.closeMgmtDropdowns();
    this.onEditGroup.emit(group);
  }

  public deleteGroup(group: IManagableObject) {
    if (!this.isDeleteAllowed(group)) return;
    let message = this.translate.instant("Delete");
    if (!confirm(message + " " + group.Name + "?")) return;
    if (this.selectedGroup == group)
      this.selectGroup(this.allGroupsItem);
    this.closeMgmtDropdowns();
    this.onDeleteGroup.emit(group);
  }

  public selectGroup(group: IManagableObject) {
    this.selectedGroup = group;
    this.closeMgmtDropdowns();
    this.onSelectGroup.emit(group);
  }

  public isEditAllowed(group: IManagableObject): boolean {
    return !this.canEditGroup || this.canEditGroup(group);
  }

  public isDeleteAllowed(group: IManagableObject): boolean {
    return !this.canDeleteGroup || this.canDeleteGroup(group);
  }

  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: MouseEvent) {
    if (!this.elementRef?.nativeElement?.contains(event.target)) {
      this.closeMgmtDropdowns();
    }
  }

  private closeMgmtDropdowns() {
    this.groups.forEach((grp: any) => grp.isMgmtOpen = false);
  }

}

